import React, {useState} from 'react';
import {ScoreChangeIndicator} from './ScoreChangeIndicator';
import {ProspectPoolInfo} from './ProspectPoolInfo';
import {ProspectPoolTotalScoreRankHistory} from 'api';
import moment from 'moment';
import {ScoreTagSection} from '../ScoreTagSection';

export const ScoreHistoryRow = ({
  history,
  history: {prospectPool = {}},
  isSelected,
  onSelect,
}: {
  history: ProspectPoolTotalScoreRankHistory;
  isSelected: boolean;
  onSelect: (historyId: string) => void;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <tr
        key={history.id}
        className="border-b border-c-border last:border-b-0 hover:bg-gray-50">
        {/* 展開アイコン */}
        <td className="py-3 px-4">
          <button
            className="w-3 h-3 bg-transparent cursor-pointer"
            onClick={toggleExpanded}>
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              className="align-middle"
              style={{
                transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out',
              }}>
              <path
                d="M4 2L8 6L4 10"
                stroke="#4D4D4D"
                strokeWidth="1.5"
                fill="none"
              />
            </svg>
          </button>
        </td>
        {/* チェックボックス */}
        <td className="py-3 px-2">
          <input
            type="checkbox"
            className="w-4 h-4 border border-gray-300 rounded align-middle"
            checked={isSelected}
            onChange={() => onSelect(history.id)}
          />
        </td>
        {/* 変動日 */}
        <td className="py-3 px-2 text-xs font-medium text-gray-700">
          {moment(history.createdDate).format('YYYY/MM/DD')}
        </td>
        {/* スコア */}
        <td className="py-3 px-2">
          <ScoreChangeIndicator
            fromRank={history.fromRank}
            toRank={history.toRank}
            fromScore={history.fromScore}
            toScore={history.toScore}
          />
        </td>
        {/* 氏名/会社情報 */}
        <td className="py-3 px-2">
          <ProspectPoolInfo prospectPool={prospectPool} />
        </td>
        {/* ステータス */}
        <td className="py-3 px-2">
          <span className="px-2 py-1 bg-blue-100 text-blue-900 rounded-full text-xs font-medium">
            {prospectPool?.stageText}
          </span>
        </td>
        {/* フェーズ */}
        <td className="py-3 px-2 text-xs text-gray-700">
          {prospectPool?.clientPhaseProspect?.name}
        </td>
        {/* 最終コールアクション */}
        <td className="py-3 px-2 text-xs text-gray-700">
          {prospectPool?.telUpdatedDate &&
            moment(prospectPool.telUpdatedDate).format('YYYY/MM/DD')}
        </td>
        {/* 担当者 */}
        <td className="py-3 px-2 text-xs font-medium text-gray-700">
          {`${prospectPool?.user?.lastName || ''} ${prospectPool?.user?.firstName || ''}`.trim()}
        </td>
      </tr>
      {/* 展開されたスコアタグセクション */}
      {isExpanded && (
        <tr className="bg-gray-50">
          <td colSpan={9} className="p-0">
            <ScoreTagSection history={history} />
          </td>
        </tr>
      )}
    </>
  );
};
